import typeJudge from "./typeJudge";

/**
 * 带过期时间的本地存储封装
 */
function Storage() {
  const STORAGE_EXPRESS = 100;
  const STORAGE_NULL = 101;

  /**
   * 设置数据存储日期 内部方法，外部无法调用
   * @param {*} data - 需要存储的数据
   * @param {number} expirationTime - 存储的时间(天)
   * @returns {object} 设置完存储时间的组装数据
   */
  var setexpirationTime = (data, expirationTime) => {
    const currentTime = Date.parse(new Date());
    const storageData = {
      expirationTime: currentTime + 86400000 * expirationTime,
      value: data
    };
    return storageData;
  };


  /**
   * 存储行为函数
   * @param {string} key - 存储的数据的key
   * @param {*} value - 存储数据的value
   * @param {number} expirationTime - 数据有效期 默认为1天
   * @throws {Error} 当key未定义或expirationTime不是数字时抛出错误
   */
  this.setStorage = (key, value, expirationTime = 1) => {
    if (!key) {
      throw new Error('Key is not defined');
    }
    if (!typeJudge.isNumber(expirationTime)) {
      throw new Error('The expiration time must be a number');
    }
    const storageData = typeJudge.objectToJson(setexpirationTime(value, expirationTime));
    localStorage.setItem(key, storageData);
  };


  /**
   * 获取存储数据行为函数
   * @param {string} key - 存储的数据的key
   * @param {boolean} naviteData - 是否获取带有过期时间戳的元数据，默认false
   * @returns {*} 存储的数据，如果不存在或已过期，返回错误对象
   */
  this.getStorage = (key, naviteData = false) => {
    if (!key) {
      console.warn('Key is not defined');
      return '';
    }
    const storageItem = localStorage.getItem(key);
    if (!storageItem) {
      return { $s_code_$exp: STORAGE_NULL, message: '数据不存在' };
    }

    const storageData = JSON.parse(storageItem);
    if (naviteData) {
      return storageData;
    }

    const { expirationTime, value } = storageData;
    const currentTime = Date.parse(new Date());
    if (expirationTime > currentTime) {
      return value || null;
    } else {
      return { $s_code_$exp: STORAGE_EXPRESS, message: '数据已过期' };
    }
  };


  /**
   * 删除指定数据
   * @param {string} key - 存储的数据的key
   */
  this.deleteStorage = (key) => {
    if (key) {
      localStorage.removeItem(key);
    }
  };
}




/**
 * 内存存储封装类
 */
function Store() {
  this.init = () => {
    // 初始化方法
  };
  this.init.call(this);

  /**
   * 设置系统变量
   * @param {string} key - 要设置的变量对象名称，支持set('con.a.v', val) 多级对象设置
   * @param {*} value - 要设置的值
   * @returns {*} 返回设置的对象
   */
  var set = (key, value) => {
    if (!key) {
      console.warn('Key is required for set operation');
      return null;
    }

    if (key.indexOf('.') > -1) {
      const enKey = key.split('.');
      if (!this[enKey[0]]) {
        this[enKey[0]] = {};
      }
      let memoryKey = this[enKey[0]];
      
      for (let i = 1; i < enKey.length; i++) {
        if (i === enKey.length - 1) {
          memoryKey[enKey[i]] = value;
          break;
        } else {
          if (!memoryKey[enKey[i]]) {
            memoryKey[enKey[i]] = {};
          }
          memoryKey = memoryKey[enKey[i]];
        }
      }
      return this[enKey[0]];
    }
    this[key] = value;
    return this[key];
  };


  /**
   * 获取系统变量的值
   * @param {string} key - 要获取的变量对象名称，支持get('con.a.v') 多级对象获取
   * @returns {*} 匹配到的对象的值
   */
  var get = (key) => {
    if (!key) {
      console.warn('Key is required for get operation');
      return null;
    }

    if (key.indexOf('.') > -1) {
      const enKey = key.split('.');
      if (!this[enKey[0]]) {
        console.warn(`目标对象: ${key} 并不存在`);
        return '';
      }
      let memoryKey = this[enKey[0]];
      
      for (let i = 1; i < enKey.length; i++) {
        if (i === enKey.length - 1) {
          if (memoryKey && memoryKey[enKey[i]] !== undefined) {
            return memoryKey[enKey[i]];
          } else {
            console.warn(`目标对象: ${key} 并不存在`);
            return '';
          }
        } else {
          if (!memoryKey[enKey[i]]) {
            console.warn(`目标对象: ${key} 并不存在`);
            return '';
          }
          memoryKey = memoryKey[enKey[i]];
        }
      }
      return memoryKey;
    }
    return this[key];
  };

  
  /*
    showAllData { Function } 查看当前保存的所有数据
    @param 无
    @return {Array} 返回所有数据数组

  */
  var showAllData = () => {
    let keys = Object.keys(this);
    let dataSource = [];
    keys.forEach(key => {
      dataSource.push({
        key,
        value: this[key]
      })
    })
    return dataSource;
  }


  /**
   * 从整个类中删除指定的一个对象
   * @param {string} key - 要删除的对象
   */
  var dele = (key) => {
    if (key && this[key] !== undefined) {
      delete this[key];
    }
  };

  return {
    set,
    get,
    dele,
    showAllData
  }

}
var xwjStore = new Store();
var storage = new Storage();
export {xwjStore,storage}
